import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';
import { MutateBulkRequestResponse } from '@app/store/transport-layer/bulk-request/bulk-requests';

export function putBulkRequestsTitle(
  workspaceId: string,
  bulkRequestId: string,
  data: {
    title: string;
  }
): Promise<MutateBulkRequestResponse> {
  return requestApi<MutateBulkRequestResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/title`),
    method: 'PUT',
    credentials: true,
    data,
  }).then((response) => response.data);
}
